import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../../../components/Button/Button';
import styles from './PrivateButtons.module.scss';
import React, { useState } from 'react';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../../../components/Modals/DeleteModal/DeleteModal';
import { deleteRequestGuild, getOneGuild, requestGuild } from '../../../store/reducers/Guild/guildRequest';
import { useAppDispatch } from '../../../store/reducers';
import { useParams } from 'react-router-dom';
const PrivateButtons = ({ guildInfoData }) => {
    const { t } = useTranslation();
    const [requestGuildModal, setRequestGuildModal] = useState(false);
    const [cancelGuildModal, setCancelGuildModal] = useState(false);
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const openModal = {
        send: () => setRequestGuildModal(true),
        cancel: () => setCancelGuildModal(true)
    };
    const handleClick = async () => {
        await dispatch(deleteRequestGuild(guildInfoData.request.id));
        if (id) {
            dispatch(getOneGuild(id));
        }
    };
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [!(guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.request) ? (_jsx(Button, { color: 2, className: styles.button, height: 'sm', onClick: () => openModal['send'](), text: t('send_request') })) : (_jsx(Button, { color: 2, onClick: () => openModal['cancel'](), className: styles.button, height: 'sm', text: t('cancel_request') })), requestGuildModal && (_jsx(DeleteModal, { label: GuildActionsName.REQUEST, buttonName: t('request'), onClick: () => dispatch(requestGuild(guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.id)), title: `${t('are_you_sure_to_want_to_request_to_guild')}?`, closeModal: () => setRequestGuildModal(false) })), cancelGuildModal && (_jsx(DeleteModal, { label: GuildActionsName.CANCEL_REQUEST, buttonName: t('cancel_request'), onClick: handleClick, title: `Are you sure to want to cancel [${guildInfoData === null || guildInfoData === void 0 ? void 0 : guildInfoData.name}] to guild?`, closeModal: () => setCancelGuildModal(false) }))] })));
};
export default PrivateButtons;
